// Legacy worker to match the legacy main-thread build that vite.config.ts aliases in.
import workerUrl from "pdfjs-dist/legacy/build/pdf.worker.min.mjs?url";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

// Version-keyed so a pdfjs-dist upgrade can't pair the new worker with cached old assets.
const assets = `${import.meta.env.BASE_URL}pdfjs/${__PDFJS_VERSION__}/`;

/**
 * Options for every document the preview opens. Module-level so the object is
 * stable — react-pdf reloads the document when `options` changes identity.
 */
export const PDF_DOCUMENT_OPTIONS = {
  wasmUrl: `${assets}wasm/`,
  cMapUrl: `${assets}cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `${assets}standard_fonts/`,
  iccUrl: `${assets}iccs/`,
};
